"use client";

import { queryKeys } from "@/constants/queries.keys";
import { useCartActions } from "@/hooks/useCartActions";
import { useAuth } from "@/providers/AuthProvider";
import { usePromoCode } from "@/providers/PromoCodeProvider";
import { fetchCheckoutSummary } from "@/services/purchase/purchaseApis";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useLocale } from "next-intl";

export function useCheckoutSummary() {
  const locale = useLocale();
  const { promoCodeData, setPromoCodeData } = usePromoCode();
  const { isAuthLoading, isAuthenticated } = useAuth();

  const { cartItems, totalCartPrice, totalCartQuantity } = useCartActions();

  const {
    isLoading: isSummaryLoading,
    data: checkoutSummary,
    error,
  } = useQuery({
    queryKey: [
      queryKeys.purchase.checkoutSummary,
      totalCartPrice,
      totalCartQuantity,
      promoCodeData,
      isAuthenticated,
    ],
    queryFn: async () => {
      const response = await fetchCheckoutSummary({
        cartItems: cartItems,
        promoCode: promoCodeData ? promoCodeData.promo_code : null,
        locale,
        isAuthenticated,
      });

      if (!response.status) {
        throw new Error(response.message);
      }
      return response.data.data;
    },
    enabled: !isAuthLoading,
    placeholderData: keepPreviousData,
  });

  return {
    checkoutSummary,
    isSummaryLoading,
    promoCodeData,
    setPromoCodeData,
    error,
  };
}
